/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppLabInfo } from '../models/app-lab-info';
import { GolabAppLabDescription } from '../models/golab-app-lab-description';
import { golabLabControllerGetGolabzLabList } from '../fn/golab-lab/golab-lab-controller-get-golabz-lab-list';
import { GolabLabControllerGetGolabzLabList$Params } from '../fn/golab-lab/golab-lab-controller-get-golabz-lab-list';
import { golabLabControllerGetGraaspLabList } from '../fn/golab-lab/golab-lab-controller-get-graasp-lab-list';
import { GolabLabControllerGetGraaspLabList$Params } from '../fn/golab-lab/golab-lab-controller-get-graasp-lab-list';
import { golabLabControllerGetNotSupportedLabList } from '../fn/golab-lab/golab-lab-controller-get-not-supported-lab-list';
import { GolabLabControllerGetNotSupportedLabList$Params } from '../fn/golab-lab/golab-lab-controller-get-not-supported-lab-list';

@Injectable({ providedIn: 'root' })
export class GolabLabService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `golabLabControllerGetGolabzLabList()` */
  static readonly GolabLabControllerGetGolabzLabListPath = '/golab-lab/golabz-lab-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `golabLabControllerGetGolabzLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabLabControllerGetGolabzLabList$Response(params?: GolabLabControllerGetGolabzLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppLabDescription>>> {
    const obs = golabLabControllerGetGolabzLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `golabLabControllerGetGolabzLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabLabControllerGetGolabzLabList(params?: GolabLabControllerGetGolabzLabList$Params, context?: HttpContext): Observable<Array<GolabAppLabDescription>> {
    const resp = this.golabLabControllerGetGolabzLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<GolabAppLabDescription>>): Array<GolabAppLabDescription> => r.body)
    );
  }

  /** Path part for operation `golabLabControllerGetGraaspLabList()` */
  static readonly GolabLabControllerGetGraaspLabListPath = '/golab-lab/graasp-lab-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `golabLabControllerGetGraaspLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabLabControllerGetGraaspLabList$Response(params?: GolabLabControllerGetGraaspLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppLabDescription>>> {
    const obs = golabLabControllerGetGraaspLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `golabLabControllerGetGraaspLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabLabControllerGetGraaspLabList(params?: GolabLabControllerGetGraaspLabList$Params, context?: HttpContext): Observable<Array<GolabAppLabDescription>> {
    const resp = this.golabLabControllerGetGraaspLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<GolabAppLabDescription>>): Array<GolabAppLabDescription> => r.body)
    );
  }

  /** Path part for operation `golabLabControllerGetNotSupportedLabList()` */
  static readonly GolabLabControllerGetNotSupportedLabListPath = '/golab-lab/not-supported-lab-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `golabLabControllerGetNotSupportedLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabLabControllerGetNotSupportedLabList$Response(params?: GolabLabControllerGetNotSupportedLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLabInfo>>> {
    const obs = golabLabControllerGetNotSupportedLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `golabLabControllerGetNotSupportedLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabLabControllerGetNotSupportedLabList(params?: GolabLabControllerGetNotSupportedLabList$Params, context?: HttpContext): Observable<Array<AppLabInfo>> {
    const resp = this.golabLabControllerGetNotSupportedLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AppLabInfo>>): Array<AppLabInfo> => r.body)
    );
  }

}
